import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';

import DatePicker from 'react-datepicker';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';
import './DateInput.css';

class DateInput extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(datetime) {
    const value = datetime !== null ? datetime.format() : null;
    this.props.onChange(this.props.name, value);
  }

  render() {

    const { id,
      name,
      onChange,
      onBlur,
      value,
      dateFormat,
      timeFormat,
      timeCaption,
      placeholderText,
      ...rest } = this.props;

    const parsedDateValue = value ? moment(value) : null;

    return (
      <DatePicker
        id={name}
        name={name}
        selected={parsedDateValue}
        dateFormat={dateFormat}
        timeFormat={timeFormat}
        timeCaption={timeCaption}
        placeholderText={placeholderText}
        onChange={this.handleChange}
        {...rest}
      />
    );
  }
}

DateInput.defaultProps = {
  dateFormat: "YYYY-MM-DD",
  timeFormat: "hh:mm A",
  timeCaption: "Time"
};

DateInput.propTypes = {
  name: PropTypes.string.isRequired,
  dateFormat: PropTypes.string,
  timeFormat: PropTypes.string,
  timeCaption: PropTypes.string
};

export default DateInput;



// WEBPACK FOOTER //
// ./src/components/form/controls/DateInput.js